export const GET_SALES_INVOICE_PDF = gql`
    query viewPDFSalesInvoice($sageInvoiceId: String) {
        viewPDFSalesInvoice(sageInvoiceId: $sageInvoiceId) {
            pdfBase64
            previewUrl
        }
    }
`;
